import React, { memo } from "react";
import { Box, FormControlLabel, Grid } from "@mui/material";
import { FormikProps, useFormikContext } from "formik";
import { Data, Processor } from "../../../../../store/terminal/types";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../../store";
import AdditionalDataForm from "./additionalDataForm";
import pageStyles from "../../../../pageStyles";
import TextInput from "../../../../../common/formElements/TextInput";
import SelectDropDown from "../../../../../common/formElements/SelectDropDown";
import CustomizedSwitch from "../../../../../common/formElements/Switch";
import SectionWrapper from "../../../../../common/pageSections/SectionWrapper";
interface ProcessorForm {
  index: number;
  processor: Processor;
  isUpdateAllowed?: boolean;
}
const ProcessorForm = (props: ProcessorForm) => {
  const { index, processor, isUpdateAllowed } = props;
  const classes = pageStyles();
  const formProps = useFormikContext<FormikProps<Data>>();

  const { setFieldValue, errors } = formProps;
  const values = formProps.values as unknown as Data;

  const processors = useSelector(
    (state: ApplicationState) => state.processor.data
  );

  const processorsOptions =
    processors?.data
      ?.filter((dropDownOption) => {
        const selectedValue =
          values?.attributes?.Processor &&
          values.attributes.Processor[index].ProcessorName;
        return (
          values?.attributes?.Processor?.map(
            (processor: Processor) => processor.ProcessorName
          ).indexOf(dropDownOption.attributes.Name) === -1 ||
          dropDownOption.attributes.Name === selectedValue
        );
      })
      .map((optName) => optName.attributes.Name) || [];

  return (
    <Grid container alignItems="flex-start" spacing={2}>
      <Grid item xs={12} md={4}>
        {processorsOptions.length && (
          <SelectDropDown
            fieldname={`attributes.Processor[${index}].ProcessorName`}
            label="Name"
            options={processorsOptions}
            disabled={!isUpdateAllowed}
          />
        )}
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.Processor[${index}].MID`}
          label="MID"
          disabled={!isUpdateAllowed}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.Processor[${index}].PPID`}
          label="Pin Pad ID"
          disabled={!isUpdateAllowed}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.Processor[${index}].STAN`}
          label="STAN"
          disabled={!isUpdateAllowed}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.Processor[${index}].TID`}
          label="TID"
          disabled={!isUpdateAllowed}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <SectionWrapper title="Configuration" isChild>
          <Box p={2} pt={0}>
            <FormControlLabel
              style={{ marginRight: "3rem" }}
              control={
                <CustomizedSwitch
                  checked={
                    values.attributes.Processor[index]
                      .ReversalPending as boolean
                  }
                  onChange={(event) => {
                    setFieldValue(
                      `attributes.Processor[${index}].ReversalPending`,
                      event.target.checked
                    );
                  }}
                  disabled={!isUpdateAllowed}
                />
              }
              label="Reversal Pending"
            />
            <FormControlLabel
              style={{ marginRight: "3rem" }}
              control={
                <CustomizedSwitch
                  checked={
                    values.attributes.Processor[index]
                      .CompletionPending as boolean
                  }
                  onChange={(event) => {
                    setFieldValue(
                      `attributes.Processor[${index}].CompletionPending`,
                      event.target.checked
                    );
                  }}
                  disabled={!isUpdateAllowed}
                />
              }
              label="Completion Pending"
            />
          </Box>
        </SectionWrapper>
      </Grid>
      <Grid item xs={12}>
        <hr className={classes.devide} />
        <AdditionalDataForm
          isUpdateAllowed={isUpdateAllowed}
          index={index}
          processor={processor}
        />
      </Grid>
    </Grid>
  );
};
export default memo(ProcessorForm);
